import { Output, EventEmitter, HostListener } from "@angular/core";
import { PresentationOption } from "./../../../vo/presentation-option";
import { CourseContextModelService } from "./../../../models/course-context-model.service";
import {
	Component,
	OnInit,
	Input,
	SimpleChanges
} from "@angular/core";
import { CourseTimerService } from "../../../../services/course-timer.service";
import { Subscription } from "rxjs";
import { UtilityScripts } from "../../../../helpers/utility-scripts";
import { AppServices } from "app/app.services";
import { ApplicationModel } from "app/core/models/application.model";
import { ModalPopupService } from "app/services/modal-popup.service";
import { ScreenControllerService } from "app/core/controls/screen-controller.service";
import { OrientationModelService } from "app/core/models/orientation-model.service";
import { TrackingManager } from "app/core/tracking/tracking-manager";
@Component({
	selector: "app-app-page-header-adaptive",
	templateUrl: "./app-page-header.component.html",
	styleUrls: ["./app-page-header.component.scss"],
})
export class AppPageHeaderComponentAdaptive implements OnInit {
	@Input() curPageNum: number;
	@Input() totalPages: number;
	@Input() totalPagesInCourse: number;

	private percentComplete: string = "";
	private presentationModes: any[];
	public pModeOpen: boolean;
	public courseTime: string = "0:00:00";
	public bShowCourseTime: boolean = false;
	private courseTimeSubscription: Subscription;
	private courseCompletedSubscription: Subscription;
	private pageTitleSubscription: Subscription;
	private isCourseCompleted = false;
	private percentVal = 0;
	private pageTitle: string;
	private _OS: string;

	@Output() presMode: EventEmitter<string> = new EventEmitter();

	constructor(
		private courseContextModelService: CourseContextModelService,
		private courseTimerService: CourseTimerService,
		private appServices: AppServices,
		private modalPopupService: ModalPopupService,
		private screenController: ScreenControllerService,
		public orientationModel: OrientationModelService
	) {
		this.pModeOpen = false;
		this.presentationModes = courseContextModelService.presentationModes;
		for (let item of this.presentationModes) {
			item.showTooltip = false;
		}
		console.log("|||||||||||||||||||||||||||||||||||||||||||||||||||||");
		console.log(courseContextModelService.presentationModes);
		console.log("|||||||||||||||||||||||||||||||||||||||||||||||||||||");
		this.courseTimeSubscription = this.courseTimerService.notifier.subscribe(
			(data) => {
				if (data.type == "demo") {
					this.handleCourseTime(data.totalTime);
				} else if (data == "complete") {
					if (ApplicationModel.instance.bLastPageReached) {
					}
				} else if (data.totalTime) {
					this.handleCourseTime(data.totalTime);
				} else if (data.available) {
					this.bShowCourseTime = data.available;
				}
			}
		);
		this.courseCompletedSubscription = appServices.courseCompleted$.subscribe(
			(event) => this.courseCompletedHandler()
		);
	}

	ngOnInit() {
		this.pageTitleSubscription = this.appServices.updatePageTitle$.subscribe(
			(event) => (this.pageTitle = event.title)
		);
		this._OS = UtilityScripts.getSystemDetails()["os"].toLowerCase();
	}

	ngOnChanges(simplechanges: SimpleChanges) {
		this.updateProgress();
		this.updatePercentVal();
		this.presentationModes = this.courseContextModelService.presentationModes;
	}

	private courseCompletedHandler() {
		this.isCourseCompleted = true;
		this.updateProgress();
		this.updatePercentVal();
	}

	private handleCourseTime(totalTime) {
		this.courseTime = UtilityScripts.getClockFormat(totalTime);
	}

	private updateProgress() {
		let percentage;
		if (
			this.isCourseCompleted ||
			ApplicationModel.instance.mode == "demo" ||
			TrackingManager.instance.trackingVO.lessonStatus == "p" ||
			TrackingManager.instance.trackingVO.lessonStatus == "c"
		)
			this.percentComplete = "100%";
		else if (this.curPageNum == this.totalPagesInCourse - 1)
			this.percentComplete = "99%";
		else {
			percentage = Math.floor(
				(this.curPageNum / this.totalPagesInCourse) * 100
			);
			this.percentComplete = percentage + "%";
			if (percentage > 99) {
				this.percentComplete = "99%";
			}
		}
	}

	public get percentCompleteVal(): string {
		return this.percentComplete;
	}

	private updatePercentVal() {
		if (
			this.isCourseCompleted ||
			ApplicationModel.instance.mode == "demo" ||
			TrackingManager.instance.trackingVO.lessonStatus == "p" ||
			TrackingManager.instance.trackingVO.lessonStatus == "c"
		)
			this.percentVal = 100;
		else if (this.curPageNum == this.totalPagesInCourse - 1)
			this.percentVal = 99;
		else {
			this.percentVal = Math.ceil(
				(this.curPageNum / this.totalPagesInCourse) * 100
			);
			if (this.percentVal > 99) {
				this.percentVal = 99;
			}
		}
	}

	public get percentProgressVal(): number {
		return this.percentVal;
	}
	public get currentPageTitle(): string {
		return this.pageTitle;
	}

	public get currentModuleTitle(): string {
		return this.courseContextModelService.currentModuleTitle();
	}

	public presentationClick(event) {
		this.pModeOpen = !this.pModeOpen;
	}

	public get presentationModeOptions(): PresentationOption[] {
		return this.presentationModes;
	}

	public get selectedPresentationMode(): PresentationOption {
		return this.courseContextModelService.selectedPresentationMode;
	}

	public modeSelect(item: any) {
		this.hideAllTooltip();
		item.showTooltip =
			this._OS.indexOf("ios") != -1 || this._OS.indexOf("os x") != -1
				? true
				: false;
		this.presMode.emit(item.mode);
		this.pModeOpen = false;
	}

	public get textDirection() {
		return ApplicationModel.instance.flowDirection;
	}

	public mouseover(item) {
		item.showTooltip = true;
	}

	public mouseout(item) {
		item.showTooltip = false;
	}

	@HostListener("document:mousedown", ["$event"])
	onGlobalClick(event): void {
		if (
			event &&
			event.target &&
			!event.target.classList.contains("page-header-icon-selected") &&
			!event.target.classList.contains("page-header-icon") &&
			event.target.classList.value != ""
		) {
			this.pModeOpen = false;
			this.hideAllTooltip();
		}
	}
	private hideAllTooltip() {
		if (this._OS.indexOf("ios") != -1 || this._OS.indexOf("os x") != -1) {
			this.presentationModes.forEach(
				(pMode: any) => (pMode.showTooltip = false)
			);
		}
	}
	public getLeftpos(elem: any, type: string) {
		const width: any = parseInt(getComputedStyle(elem).width.replace("px", ""));
		let _left: any;
		switch (type) {
			case "pmodebtn":
				_left = `-${width + 8}px`;
				break;
			case "pmodeoptions":
				_left = `-${width + 6}px`;
				break;
			case "browser_pmodeoptions":
				_left = `-${width / 3 + 2}px`;
				break;
		}
		return _left;
	}
}
